module.exports = __webpack_public_path__ + "img/cp-small.96508b17.png";